module.exports = __webpack_public_path__ + "img/ideation-06-benchmarking-sample-02.55fd7044.jpg";